var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCertificate = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 0v16h14V0zm13 15H2V1h12zM3 3h5v1H3zm0 2h5v1H3zm0 2h5v1H3zm0 1.99h5v1H3zM3 11h5v1H3zm0 2h10v1H3zm10-9.586L12.414 4l.586.586V5h-1v1h-.414L11 5.414 10.414 6H10V5H9v-.414L9.586 4 9 3.414V3h1V2h.414l.586.586.586-.586H12v1h1z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 7v4.5l-1-1-1 1V7z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCertificate);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/certificate.svg";